import { Column } from '@devexpress/dx-react-grid';

export const WP_SITE_CONNECTION_REPORT = 'WP Site Connections';

export const WP_SITE_CONNECTIONS_REPORT_MESSAGE =
  `This report shows all active repairers that are currently connected to this work provider. 
  The data shown is based on the Data Access Profile assigned to your account. As a result, you may not see all repairers if your profile does not have permission to view them.`;

export const WP_SITE_CONNECTION_REPORT_GRID_TITLE = 'wpSiteConnectionsReport';

export const columns: Column[] = [
  { name: 'repairerGroup', title: 'Group' },
  { name: 'siteCode', title: 'Site Code' },
  { name: 'capsCodes', title: 'CAPS Codes' },
  { name: 'name', title: 'Name' },
  { name: 'address', title: 'Address' },
  { name: 'postcode', title: 'Postcode' },
  { name: 'systemType', title: 'System Type' },
  { name: 'connectionDetails', title: 'Connection Details' },
];

export const tableColumnExtensions = [
  { columnName: 'repairerGroup', wordWrapEnabled: true },
  { columnName: 'siteCode', wordWrapEnabled: true },
  { columnName: 'capsCodes', wordWrapEnabled: true },
  { columnName: 'name', wordWrapEnabled: true },
  { columnName: 'address', wordWrapEnabled: true },
  { columnName: 'postcode', wordWrapEnabled: true },
  { columnName: 'systemType', wordWrapEnabled: true },
  { columnName: 'connectionDetails', wordWrapEnabled: true },
];